export { default as ArrowRightIcon } from './ArrowRightIcon'
export { default as ForbiddenAccessIcon } from './ForbiddenAccessIcon'
export { default as PasswordFingerprintIcon } from './PasswordFingerprintIcon'
